import React from 'react';
import { usePermissions } from '../utils/permissions';

/**
 * Conditionally renders children based on user permissions.
 * 
 * @param {Object} props
 * @param {string|string[]} props.permission - Permission(s) required to show children.
 * @param {React.ReactNode} props.children - Content to show if user has permission.
 * @param {React.ReactNode} [props.fallback] - Content to show if user lacks permission.
 */
const HasPermission = ({ permission, children, fallback = null }) => {
  const { can } = usePermissions();

  if (can(permission)) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};

export default HasPermission;
